<div class="sectors">
    <!-- TODO: ask Cyrille if display data ok
    <all-segment-list [segmentList]="itineraryChangeInformation.sector"></all-segment-list>
    -->
    <div *ngFor="let sector of sectorTable; let i = index">
        <sector class="card-body-content-sector" [sectorItem]="sector"></sector>
        <span *ngIf="i == indexSeparation" class="separation"></span>
    </div>

</div>

<div class="travellersTotal">
    <div class="travellers">
        <div class="traveller" *ngFor="let traveller of itineraryChangeInformation.traveller">
            <booking-traveller-abstract [traveller]="traveller" [isInline]="true"></booking-traveller-abstract>
        </div>
    </div>
    <div class="total">
        <div *ngFor="let total of itineraryChangeInformation.total">
            {{itineraryChangeInformationWording.total}}&nbsp;
            <strong [innerHTML]="total.value | price:total.currency"></strong>
            <br>
            <span *ngIf="addPrice && getPriceAfterAdd(total.value) as newTotal">
                {{itineraryChangeInformationWording.totalAfterAdd}}&nbsp;
                <strong [innerHTML]="newTotal | price:total.currency"></strong>
            </span>
        </div>
    </div>
</div>

